import React, { useState, useEffect } from "react";
import { Keyboard } from "@capacitor/keyboard";
import { useCartData } from "../../../../providers/cartDataStore";
import { useHistory, useLocation } from "react-router";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Capacitor, PluginListenerHandle } from "@capacitor/core";
import { useGetMinimumOrderAmount } from "../../../../hooks";
import { prettifyNumbers } from "../../../../utils/prettifyNumbers";

const PRODUCT_PATHS = ["category-detail", "product-shelf", "home3", "promo", "categories", "wish-list"];

const CartProgressButton = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { cartTotalValue, cartSubtotalValue } = useCartData();

  const [keyboardHeight, setKeyboardHeight] = useState<number | null>(null);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    let showSub: PluginListenerHandle;
    let hideSub: PluginListenerHandle;

    const setupListeners = async () => {
      showSub = await Keyboard.addListener("keyboardWillShow", (info) => {
        setKeyboardHeight(info.keyboardHeight);
      });

      hideSub = await Keyboard.addListener("keyboardWillHide", () => {
        setKeyboardHeight(null);
      });
    };

    setupListeners();

    return () => {
      showSub?.remove();
      hideSub?.remove();
    };
  }, []);

  const { minimumOrderAmount, isMinimumAmountReached, amountToRaise } = useGetMinimumOrderAmount();
  const progress = Math.min((cartSubtotalValue / minimumOrderAmount) * 100, 100);

  const handleGoToCart = () => {
    history.push("/cart");
  };

  const shouldHideButton = !PRODUCT_PATHS.some((path) => location.pathname.includes(path)) || keyboardHeight !== null; // скрывать при открытой клавиатуре

  if (shouldHideButton) {
    return null;
  }

  const roundedRemainingAmount = prettifyNumbers(amountToRaise);

  const roundedCartTotalValue = prettifyNumbers(cartTotalValue);

  return (
    <div
      onClick={handleGoToCart}
      className={cx(
        "w-[8.5rem] h-14 mr-[1.5rem] rounded-3xl overflow-hidden bg-[#fed7006b] pointer-events-auto relative",
      )}
    >
      <div
        style={{ width: `${progress}%` }}
        className={cx("absolute z-[-1] h-full transition-width duration-300 bg-primary w-[3rem]")}
      />
      <div className="w-full h-full flex flex-col justify-center items-center py-[0.875rem] px-[1.5rem]">
        {isMinimumAmountReached ? (
          <>
            <div className="font-bold text-sm">{t("Go cart")}</div>
            {cartTotalValue > 0 && <div className="font-bold text-xs">{roundedCartTotalValue} ₽</div>}
          </>
        ) : (
          <>
            <div className="font-bold leading-[0.8125rem]">{roundedCartTotalValue} ₽</div>
            <div className="text-[0.5625rem]">
              {t("add_more_text")} {roundedRemainingAmount}₽
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartProgressButton;
